import { render } from "./ClaimSection.vue?vue&type=template&id=7e6bd512"
import script from "./ClaimSection.vue?vue&type=script&lang=js"
export * from "./ClaimSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__